import { render } from "./EmailReviewModal.vue?vue&type=template&id=36676e06&scoped=true&ts=true"
import script from "./EmailReviewModal.vue?vue&type=script&lang=ts"
export * from "./EmailReviewModal.vue?vue&type=script&lang=ts"

import "./EmailReviewModal.vue?vue&type=style&index=0&id=36676e06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36676e06"]])

export default __exports__